import version from '@/version';

export const getAppVersion = () => {
  return version.releaseHash;
};
